// extracted by mini-css-extract-plugin
export default {"mobileDetailsContainer":"MobileDetails_mobileDetailsContainer__+IENp","buttonContainer":"MobileDetails_buttonContainer__dL1cB"};